import { z } from 'zod';
export const passkeyOptionsResponseSchema = z.object({
    options: z.record(z.string(), z.unknown()),
});
export const passkeyFinishRequestSchema = z.object({
    response: z.record(z.string(), z.unknown()),
});
export const offerPasskeyResponseSchema = z.object({
    status: z.literal('offer-passkey'),
});
//# sourceMappingURL=passkey.js.map